<template>
  <div v-if="show">
    <b-modal
      id="modal-enviar-email"
      :visible="true"
      title="Troca de senha"
      :header-bg-variant="variant"
      header-text-variant="light"
      hide-footer
      centered
      @hidden="$emit('close')"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-overlay :show="loadingEmail">
            <span>Digite seu CPF: </span>
            <div class="d-flex flex-column flex-sm-row align-items-center">
              <b-form-input
                :value="cpfFormatted"
                @input="onCpfInput"
                placeholder="CPF"
                v-bind="cpfLoginInputProps"
                class="mb-2 mb-sm-0 flex-grow-1"
                autofocus
              />
              <b-button
                class="ml-0 ml-sm-3 d-flex align-items-center"
                :disabled="cpfDigits === ''"
                type="submit"
                size="sm"
                variant="secondary"
              >
                <div>Enviar</div>
              </b-button>
            </div>
          </b-overlay>
        </b-form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { UtilsTS } from "@/utilsts";

@Component({
  components: { ValidationObserver },
})
export default class ModalTrocaSenha extends mixins(UtilsTS, Vue) {
  @Prop({ type: Boolean, required: true }) show!: boolean;
  @Prop({ type: String, required: true }) cpfDigits!: string;
  @Prop({ type: Boolean, required: true }) loadingEmail!: boolean;
  @Prop({ type: String, required: true }) variant!: string;

  cpfTooLong = false;

  get cpfLoginInputProps() {
    return {
      ...this.cpfMaskedInputProps,
      autocomplete: "username",
    };
  }

  get cpfFormatted(): string {
    return this.formatCpfMask(this.cpfDigits || "");
  }

  onSubmit(): void {
    if (this.cpfTooLong || (this.cpfDigits || "").length !== 11) {
      this.$toast.error("CPF invalido. Digite 11 digitos.");
      return;
    }
    this.$emit("submit");
  }

  onCpfInput(value: string): void {
    const digits = this.digitsOnly(value);
    this.cpfTooLong = digits.length > 11;
    if (this.cpfTooLong) {
      this.$toast.error("CPF invalido. Digite 11 digitos.");
      return;
    }
    this.$emit("update:cpfDigits", digits);
  }
}
</script>
